export default __webpack_public_path__ + "static/media/0x28c388fb1f4fa9f9eb445f0579666849ee5eeb42.52b37b2f.webp";